import { useFormContext } from 'react-hook-form';
import { isNilOrEmpty } from '@@serverHelpers/index.mjs';
import { assoc, compose, defaultTo, equals, find, map, prop, propEq, propOr, uniq } from 'ramda';
import { booleanOptions } from '@@viewCommonComponents/forms/options';
import { useEffect } from 'react';
import useGetSouscriptionCustomerGranteesCitiesAndPostalCodesQuery from './useGetSouscriptionCustomerGranteesCitiesAndPostalCodesQuery.js';

const useSouscriptionCustomerInformations = ({ getMiddleBoolean, jobs }) => {
  const form = useFormContext();

  let isDigitalContractOptions = booleanOptions;

  const birthZipCodeValue = form.watch('customer.birthZipCode');
  const { getSouscriptionCustomerGranteesCitiesAndPostalCodes: getCitiesAndPostalCodes, refetch } =
    useGetSouscriptionCustomerGranteesCitiesAndPostalCodesQuery({
      variables: {
        search: birthZipCodeValue
      }
    });

  useEffect(() => {
    refetch();
  }, [birthZipCodeValue]);

  useEffect(() => {
    if (isNilOrEmpty(form.watch('customer.emails.0.value'))) {
      form.setValue('customer.isDigitalContract', false);

      isDigitalContractOptions = map((option) => {
        if (propEq('value', true, option)) {
          return assoc('disableThisOne', true, option);
        }
        return option;
      })(booleanOptions);
    }

    if (!isNilOrEmpty(form.watch('customer.CSPs.0.externalId'))) {
      form.setValue(
        'customer.CSPs.0.label',
        compose(
          prop('label'),
          defaultTo({}),
          find(propEq('value', form.watch('customer.CSPs.0.externalId')))
        )(jobs)
      );
    }
  }, []);

  const cities = compose(uniq, propOr([], 'cities'))(getCitiesAndPostalCodes);

  const birthCountryIsFrance = equals('FRANCE', form.watch('customer.birthCountry'));

  const customerIsTns = defaultTo(false, form.watch('customer.isTns'));
  const displayMadelinMonth =
    defaultTo(false, form.watch('customer.isMadelin')) &&
    getMiddleBoolean('DISPLAY_CUSTOMER_MADELIN_MONTH');

  const displayGeneralView =
    (getMiddleBoolean('ADHERENT_PROFESSION_EST_NECESSAIRE') &&
      (getMiddleBoolean('ADHERENT_PROFESSION_EST_DEMANDE_DONNEES_CONTRAT') ||
        getMiddleBoolean('ADHERENT_PROFESSION_EST_DEMANDE_DONNEES_SOUSCRIPTION')) &&
      getMiddleBoolean('ADHERENT_CAISSE_PRO_EST_NECESSAIRE') &&
      (getMiddleBoolean('ADHERENT_CAISSE_PRO_EST_DEMANDE_DONNEES_CONTRAT') ||
        getMiddleBoolean('ADHERENT_CAISSE_PRO_EST_DEMANDE_DONNEES_SOUSCRIPTION'))) ||
    (getMiddleBoolean('ADHERENT_REGIME_EST_NECESSAIRE') &&
      (getMiddleBoolean('ADHERENT_REGIME_EST_DEMANDE_DONNEES_CONTRAT') ||
        getMiddleBoolean('ADHERENT_REGIME_EST_DEMANDE_DONNEES_SOUSCRIPTION'))) ||
    (getMiddleBoolean('ADHERENT_ACTIVITE_EST_NECESSAIRE') &&
      (getMiddleBoolean('ADHERENT_ACTIVITE_EST_DEMANDE_DONNEES_CONTRAT') ||
        getMiddleBoolean('ADHERENT_ACTIVITE_EST_DEMANDE_DONNEES_SOUSCRIPTION'))) ||
    getMiddleBoolean('ADHERENT_ID_TNS_EST_NECESSAIRE') ||
    getMiddleBoolean('ADHERENT_ID_TNS_EST_DEMANDE_DONNEES_CONTRAT') ||
    getMiddleBoolean('ADHERENT_ID_TNS_EST_DEMANDE_DONNEES_SOUSCRIPTION') ||
    customerIsTns ||
    (getMiddleBoolean('ADHERENT_NSS_EST_NECESSAIRE') &&
      (getMiddleBoolean('ADHERENT_NSS_EST_DEMANDE_DONNEES_CONTRAT') ||
        getMiddleBoolean('ADHERENT_NSS_EST_DEMANDE_DONNEES_SOUSCRIPTION'))) ||
    (getMiddleBoolean('ADHERENT_ORG_RATT_EST_NECESSAIRE') &&
      getMiddleBoolean('ADHERENT_REGIME_EST_NECESSAIRE') &&
      (getMiddleBoolean('ADHERENT_REGIME_EST_DEMANDE_DONNEES_CONTRAT') ||
        getMiddleBoolean('ADHERENT_REGIME_EST_DEMANDE_DONNEES_SOUSCRIPTION'))) ||
    (getMiddleBoolean('ADHERENT_RANG_EST_NECESSAIRE') &&
      (getMiddleBoolean('ADHERENT_RANG_EST_DEMANDE_DONNEES_SOUSCRIPTION') ||
        getMiddleBoolean('ADHERENT_RANG_EST_DEMANDE_DONNEES_CONTRAT'))) ||
    (getMiddleBoolean('ADHERENT_REVENU_ANNUEL_EST_NECESSAIRE') &&
      getMiddleBoolean('ADHERENT_REVENU_ANNUEL_EST_DEMANDE_DONNEES_CONTRAT')) ||
    getMiddleBoolean('ADHERENT_TELETRANSMISSION_EST_NECESSAIRE') ||
    getMiddleBoolean('ADHERENT_OPT_NUM_EST_NECESSAIRE');

  return {
    isDigitalContractOptions,
    birthCountryIsFrance,
    cities,
    form,
    customerIsTns,
    displayMadelinMonth,
    displayGeneralView
  };
};

export default useSouscriptionCustomerInformations;
